import { render, staticRenderFns } from "./AlipayFlowHome.vue?vue&type=template&id=a4af0708&scoped=true"
import script from "./AlipayFlowHome.vue?vue&type=script&lang=js"
export * from "./AlipayFlowHome.vue?vue&type=script&lang=js"
import style0 from "./AlipayFlowHome.vue?vue&type=style&index=0&id=a4af0708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4af0708",
  null
  
)

export default component.exports